import React from 'react';
import { Form, Input } from 'semantic-ui-react';

const LoginEmailField = (props) => (
    <Form.Field>
        <label style={{ color: '#1FA637' }}>Email</label>
        <Input
            ref={props.inputRef}
            value={props.email}
            disabled={props.isSigningIn}
            onChange={props.onChange}
            autoComplete="email"
        />
    </Form.Field>
);

export default LoginEmailField; 